import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { getApiErrorMessage, listIntakeRoutes } from '../../api/client';
import type { IntakeRouteSummary } from '../../api/types';
import Badge from '../../components/Badge';
import { useAuth } from '../../contexts/AuthContext';
import { canEditPlatformConfig, canWritePlatformConfig } from '../../utils/permissions';
import { PLATFORM_CONFIG } from '../platform-config/paths';

export default function IntakeRoutesPage() {
  const { user } = useAuth();
  const [routes, setRoutes] = useState<IntakeRouteSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const canCreate = user && canWritePlatformConfig(user);
  const canModify = user && canEditPlatformConfig(user);

  useEffect(() => {
    listIntakeRoutes()
      .then(setRoutes)
      .catch((err) => setError(getApiErrorMessage(err)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {canCreate && (
        <div className="page-header" style={{ marginTop: 0 }}>
          <div />
          <Link to={PLATFORM_CONFIG.routingNew} className="btn btn-primary">
            Add route
          </Link>
        </div>
      )}
      {error && <div className="alert alert-error">{error}</div>}
      <div className="card">
        {loading ? (
          <div className="loading">Loading intake routes…</div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Channel</th>
                <th>Audience</th>
                <th>Department</th>
                <th>Order</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {routes.map((route) => (
                <tr key={route.id}>
                  <td>
                    {canModify ? (
                      <Link to={PLATFORM_CONFIG.routingRule(route.id)}>
                        {route.name || '—'}
                      </Link>
                    ) : (
                      route.name || '—'
                    )}
                  </td>
                  <td>{route.channelType.name}</td>
                  <td>{route.audience ?? 'Any'}</td>
                  <td>{route.primaryDepartment.name}</td>
                  <td>{route.sortOrder}</td>
                  <td>
                    <Badge
                      label={route.isActive ? 'ACTIVE' : 'INACTIVE'}
                      className={route.isActive ? 'badge-success' : 'badge-neutral'}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
